export default "__VITE_ASSET__Dia26aTP__"